import { Extension } from '@tiptap/core';

const ALIGNABLE_TYPES = ['paragraph', 'heading'];

export const LetterAlignmentExtension = Extension.create({
  name: 'letterAlignment',

  addGlobalAttributes() {
    return [
      {
        types: ALIGNABLE_TYPES,
        attributes: {
          align: {
            default: null,
            parseHTML: (element) => {
              const value = element.style.textAlign || element.getAttribute('data-align');
              if (value === 'left' || value === 'center' || value === 'right') return value;
              return null;
            },
            renderHTML: (attributes) => {
              if (!attributes.align) return {};
              return {
                style: `text-align: ${attributes.align}`,
                'data-align': attributes.align,
              };
            },
          },
        },
      },
    ];
  },

  addCommands() {
    return {
      setLetterAlign:
        (align) =>
        ({ commands }) => {
          if (!['left', 'center', 'right'].includes(align)) return false;
          if (this.editor.isActive('heading')) {
            return commands.updateAttributes('heading', { align });
          }
          return commands.updateAttributes('paragraph', { align });
        },
      unsetLetterAlign:
        () =>
        ({ commands }) => {
          if (this.editor.isActive('heading')) {
            return commands.updateAttributes('heading', { align: null });
          }
          return commands.updateAttributes('paragraph', { align: null });
        },
    };
  },
});

export default LetterAlignmentExtension;
